const AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED';

const LOGIN_SELECTED = 'LOGIN_SELECTED';
const LOGIN_REQUESTED = 'LOGIN_REQUESTED';
const LOGIN_SUCCEEDED = 'LOGIN_SUCCEEDED';
const LOGIN_FAILED = 'LOGIN_FAILED';

const REGISTRATION_SELECTED = 'REGISTRATION_SELECTED';
const REGISTRATION_SUCCEEDED = 'REGISTRATION_SUCCEEDED';
const REGISTRATION_FAILED = 'REGISTRATION_FAILED';
const REGISTRATION_REQUESTED = 'REGISTRATION_REQUESTED';

export {
  AUTHENTICATION_FAILED,
  LOGIN_SELECTED,
  LOGIN_REQUESTED,
  LOGIN_SUCCEEDED,
  LOGIN_FAILED,
  REGISTRATION_SELECTED,
  REGISTRATION_REQUESTED,
  REGISTRATION_SUCCEEDED,
  REGISTRATION_FAILED,
};
